import React from "react";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {FaTrash} from "react-icons/fa";

const GarrisonAnimalList = ({rows, animalOptions, onChange, onRemove, disabled, canRemove}) => {
    if (!rows.length) return null;

    const usedValues = rows
        .map(row => (row.animalId != null && row.animalId !== "" ? String(row.animalId) : null))
        .filter(Boolean);

    return (
        <div className="border border-[#ccc] rounded-md p-3 grid grid-cols-4 gap-4">
            {rows.map((row) => {
                const selected = animalOptions.find(option => String(option.value) === String(row.animalId)) ?? null;
                const options = animalOptions.map(option => ({
                    ...option,
                    isDisabled: String(option.value) !== String(row.animalId) && usedValues.includes(String(option.value)),
                }));

                return (
                    <div className="flex items-center gap-4" key={row.tempId}>
                        <SelectComponent
                            classNameWrapper="!bg-[#fdfdee] flex-1"
                            label="Animal"
                            options={options}
                            isDisabled={disabled}
                            isClearable={!disabled}
                            value={selected}
                            onChange={(option) => onChange(row.tempId, option?.value ?? "")}
                        />
                        {canRemove &&
                            <Button target="danger" title="Remover animal" onClick={() => onRemove(row.tempId)}><FaTrash/></Button>
                        }
                    </div>
                );
            })}
        </div>
    );
};

export default GarrisonAnimalList;